import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ddd3520")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_export_button = _resolveComponent("export-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.onImportClicked }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.enterOutline
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Import')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.onAddClicked }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.addCircleOutline
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Add Guest')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Guests')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_title, { class: "custom ion-padding-top" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Summary')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, { class: "summary-box" }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.summaryRowList, (row, idx) => {
                return (_openBlock(), _createBlock(_component_ion_row, {
                  class: "summary-row",
                  key: idx
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, { class: "summary-left" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_col, { class: "summary-right" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_text, {
                          color: row.value < 0 ? 'danger' : ''
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(row.value), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"right"} }, {
                    default: _withId(() => [
                      _createVNode(_component_export_button, {
                        useFab: false,
                        endPoint: _ctx.apiEndpoints.exportGuests,
                        shareTitle: "My Guest List",
                        shareText: "Attached is your wedding guest list.  We suggest you email to yourself if you don't have Google Sheets or Microsoft Excel."
                      }, null, 8, ["endPoint"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withId(() => [
              _createVNode(_component_ion_row, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_col, { size: "7" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_title, { class: "custom ion-padding-top" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Guest Status')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-right",
                    size: "5"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        size: "small",
                        style: {"margin-right":"20px"},
                        onClick: _ctx.onSearchClicked
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Find Guest')) + "   ", 1),
                          _createVNode(_component_ion_icon, { icon: _ctx.searchOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.guestStatuses, ([idx,statusRow]) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  key: idx,
                  button: "",
                  onClick: ($event: any) => (_ctx.onStatusClicked(statusRow.statusId))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_icon, {
                      color: statusRow.color,
                      icon: statusRow.icon,
                      slot: "start"
                    }, null, 8, ["color", "icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(statusRow.title), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_note, { slot: "end" }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.guestStats[idx]), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})